import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { of } from 'rxjs';
import { FuelCardNotificationComponent } from '../components/fuel-card-notification/fuel-card-notification.component';
import { ErrorWrapper } from '../../shared/models/error-wrapper';
import { TranslateService } from '../../core/translate/translate.service';
import { ValidationFailure } from '../../shared/models/validation-failure';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(private _modalService: MatDialog,
              private _translate: TranslateService
  ) {
  }

  public handleError = (error: HttpErrorResponse) => {
    if (error?.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error?.error?.message);
    } else {
      const validationError: ErrorWrapper = <ErrorWrapper>error?.error['data'];
      this.openErrorModal(validationError);
    }

    return of(null);
  }

  private openErrorModal(error: ErrorWrapper): void {
    const modalRef: MatDialogRef<FuelCardNotificationComponent> = this._modalService.open(FuelCardNotificationComponent);
    const err: { errorMessage: string } = {
      errorMessage: `${ this._translate.data['core.genericError'] }`
    };

    modalRef.componentInstance.error = err;
  }
}
